import { FC } from "react"
import { path$ } from "src/framework/store";
import theme from "src/theme/light";
import styled from "styled-components";

const Page404Container = styled.div(props => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "center",
    justifyItems: "center",
    alignContent: "center",
    alignItems: "center",
    height: "100%",
}));

const HeaderPage = styled.h1`
    color: ${theme.palette.grey[500]};
    font-size: 10rem;
    line-height: 10rem;
    display: flex;
    font-weight: 100;
    margin: 0px;
    & div {
        display: block;
        font-size: 2.5rem;
        color: ${theme.palette.grey[300]};
        margin-right: 7px;
        transform: rotate(-90deg);

    }
`
const Page404: FC = () => {

    const location = path$.getValue();

    return <Page404Container>
        <HeaderPage><div>Error</div>404</HeaderPage>
        <span>Página não encontrada <strong>{location?.pathname}</strong></span>
    </Page404Container>
}

export { Page404 }